import styles from './company-logo.module.css';

type Props = {
  readonly src: string;
  readonly companyId: number;
};

export function CompanyInformationCompanyLogo({src, companyId}: Props) {
  return (
    <a
      href={`/main/html/searchrlp/company_id/${companyId}`}
      aria-label='企業ページへ移動'
    >
      <img src={src} alt='' className={styles.image} width={125} height={125} />
    </a>
  );
}
